<template>
    <div style="overflow-y:auto; height: 50vh" class="pa-4">
        <v-data-table
            :headers="headers"
            :items="files"
            :loading="loading"
            fixed-header
            height="30vh"
            hide-default-footer
            :items-per-page="itemsPerPage"
        >
            <template v-slot:item="{ item }">
                <tr>
                    <td :class="item.disabled ? 'red--text' : ''">{{ item.file_name }}</td>
                    <td>
                        <v-btn
                            outlined
                            color="primary"
                            @click="displayFilePreview(item)"
                            x-small
                            class="mr-4"
                            :disabled="item.disabled"
                        >
                            View
                        </v-btn>

                        <v-btn
                            depressed
                            x-small
                            @click="deleteFile(item)"
                            :disabled="item.disabled"
                        >
                            <v-icon
                                small
                                left
                            >
                                mdi-delete
                            </v-icon>
                            Delete
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <v-dialog
            v-model="filePreview"
            max-width="90vw"
            persistent
        >
            <v-card height="80vh" >
                <iframe ref="pdf" style="width:100%; height:90%;" frameBorder="0" :src="src"></iframe> 
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        depressed
                        @click="filePreview = false"
                        class="mr-4"
                    >
                        Close Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogDelete"
            width="500"
            persistent
        >
            <v-card>
                <v-card-title class="text-h6 pl-4 white--text primary">
                    Delete File?
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogDelete = false">
                        <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="text-h6 font-weight-regular pa-4">
                    This action can't be undone.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4"> 
                    <v-spacer></v-spacer>
                    <v-btn class="mr-4" depressed @click="dialogDelete = false" small>Cancel</v-btn>
                    <v-btn color="primary" @click="deleteFileConfirm" small>Yes Delete</v-btn>
                </v-card-actions>
            </v-card>   
        </v-dialog>

        <v-snackbar
            v-model="snackBar.display"
            :timeout="3000"
            :color="snackBar.color"
        >
            {{ snackBar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    v-bind="attrs"
                    text
                    @click="snackBar.display = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>

         <v-overlay
            absolute
            :value="overlay"
            color="white"
            opacity="0.60"
        >
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import UploadService from "../services/UploadFileService";

export default {
    created: function () {
        this.initialize();
    },
    
    props: {
        studentId: Number,

        validate: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        records: {
            handler () {                
                this.initialize();
            }
        },

        validate: {
            handler (val) {
                if(val) setTimeout(() => this.$emit('close-overlay'), 1000);
            }
        },
    },

    computed: {
        ...mapGetters({
            editedStudent: 'students/getEditedStudent',
        }),

        

    },

    data: () => ({
        files: [],  
        src: null,
        filePreview: false,  
        headers: [
            { text: 'File', value: 'name' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        loading: false, 
        itemsPerPage: -1, 
        dialogDelete: false, 
        deleteFileData: {},
        snackBar: {
            display: false,
            text: '',
            color: '',
        },
        overlay: false,
    }),

    methods: {
        ...mapActions({
            //
        }),

        ...mapMutations({
            //
        }),

        async initialize () {
            console.log('initializing...');
            this.loading = true;
            try {
                const { data } = await UploadService.getFiles(this.studentId);
                data.forEach(file => {
                    file.disabled = true;
                    if(file.file_name) file.disabled = false;
                })
                this.files = data;  
            } catch (error) {
                if(error.response) console.log(error.response)
                else console.log(error);
            }
            
            this.loading = false;
        },

        displayFilePreview (file) {
            this.src = file.url;
            this.filePreview = true;
        },

        async deleteFile (file) {
            this.deleteFileData = file;
            this.dialogDelete = true;           
        },

        async deleteFileConfirm () {
            const { file_name, type } = this.deleteFileData;
            this.dialogDelete = false;
            this.overlay = true;
            try {
                const response = await UploadService.delete(this.studentId, file_name, type);
                console.log('response: ', response);
                this.initialize();
                this.snackBar.text = 'File Deleted';
                this.snackBar.color = 'primary';
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.snackBar.text = 'An error has occured.';
                this.snackBar.color = 'red';
            }
            this.overlay = false;
            this.snackBar.display = true;
        },

       
    }
}
</script>

<style scoped>
    
</style>